<template>
    <div class="content-view">
        <p class="top-tip fc-333 fs-14">
            <span class="fs-16 fc-theme fw-bold marginR-20">开通VIP</span>
            <span>
                点券余额:
                <span class="fw-bold">{{$store.state.userData.surplus_total_point}}</span> （1元=100点券）
            </span>
            <el-button
                @click="$router.push('/recharge')"
                type="danger"
                size="mini"
                class="marginL-20"
            >立即充值</el-button>
        </p>

        <div class="items flex">
            <div class="item text-center" v-for="(item, index) in vipType" :key="index">
                <div v-if="item.name == 'VIP半年卡'" class="recommend fc-fff bgc-theme">站长推荐</div>
                <div class="fc-theme fs-18 fw-bold">{{item.name}}</div>
                <div>{{configData[item.key] || 0}}点券/<span class="fc-theme">{{item.time}}</span> </div>
                <div>
                    原价：
                    <span class="del fc-999">{{item.old_point}}点券</span>
                </div>
                <el-button type="danger" @click="activeVip(item.key)">购买会员</el-button>
            </div>
        </div>

        <priceTab></priceTab>

        <div class="marginT-20">
            <p>说明：</p>
            <p>1、VIP会员免费功能会在0点自动更新</p>
            <!-- <p>2、会员支持多个电脑、手机同时登陆</p> -->
            <p>2、VIP套餐均为虚拟产品，一经售出，无法退货</p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import priceTab from './priceTab';
const vipType = [
    {
        name: 'VIP年卡',
        key: 'vip_year',
        time: '360天',
        old_point: '72000'
    },
    {
        name: 'VIP半年卡',
        key: 'vip_part_year',
        time: '180天',
        old_point: '36000'
    },
    {
        name: 'VIP季卡',
        key: 'vip_season',
        time: '90天',
        old_point: '18000'
    },
    {
        name: 'VIP月卡',
        key: 'vip_month',
        time: '30天',
        old_point: '6000'
    }
]
export default {
    computed: {
        ...mapState(['configData'])
    },
    components: {
        priceTab,
    },
    data() {
        return {
            vipType
        }
    },
    methods: {
        activeVip(vipType) {
            this.$confirm(
                `确定购买${this.vipType.find(item => item.key == vipType).name}? <br>
                首次注册，可以联系微信客服或者QQ客服领取免费会员或者积分`,
                '开通会员VIP',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(async () => {
                const data = await this.$fetch('/tool/members/vip', {
                    'vip_type': vipType
                })
                if (data.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '开通成功'
                    })
                    this.$store.dispatch('upDateUser')
                    setTimeout(() => {
                        this.$store.dispatch('upDateUser')
                    }, 2000)
                    setTimeout(() => {
                        this.$store.dispatch('upDateUser')
                    }, 8000)
                    setTimeout(() => {
                        this.$store.dispatch('upDateUser')
                    }, 20000)
                }
            })
        }
    },
    mounted() {
        this.$store.dispatch('upDateUser')
    }
}
</script>

<style lang="scss" scoped>
.recommend {
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
    height: 20px;
    &::after {
        border: 10px solid transparent;
        border-left: 10px solid #f13d63;
        width: 0;
        height: 0;
        position: absolute;
        right: -20px;
        content: ' '
    }
}
.items {
    margin: 20px 20px 50px 0;
}
.item {
    position: relative;
    background: rgba($color: #999999, $alpha: 0.2);
    padding: 20px 30px;
    border-radius: 8px;
    margin-right: 30px;
    & > div {
        margin-bottom: 20px;
    }
}
.del {
    text-decoration: line-through;
}
</style>
